angular.module('gm.modals')
.controller('ConfirmModalController', ConfirmModalController);

function ConfirmModalController(
  close,
  title,
  body,
  confirmButton
) {
  'ngInject';

  this.close = close;
  this.title = title;
  this.body = body;
  this.confirmButton = confirmButton;
  this.cancel = () => close('cancel');
  this.confirm = () => close('confirm');
}
